import React, {useState, useEffect} from 'react';
import {Container, Row, Col, Form, InputGroup} from 'react-bootstrap';

import {fromCents, normalizeCurrency, toCents} from '../../refundUtils';
import styles from '../Wizard.module.scss';

export const ByAmount = (props) => {
    const {stepUpdate} = props;
    const maxTotal = normalizeCurrency(props?.maxTotal);
    const savedAmount = props?.stepData?.amount;
    const initialAmount = savedAmount !== undefined && savedAmount !== null && savedAmount !== ""
        ? fromCents(Math.min(toCents(maxTotal), Math.max(0, toCents(savedAmount))))
        : maxTotal;

    const [amount, setAmount] = useState(initialAmount.toFixed(2));

    const changeHandler = e => {
        if (e.target.value === "") {
            setAmount("");
            return;
        }

        let amountInCents = Number.isFinite(+e.target.value) ? toCents(e.target.value) : 0;
        amountInCents = Math.min(toCents(maxTotal), Math.max(0, amountInCents));
        if (amountInCents === 0 && !props.hasTokens) setAmount("");
        else setAmount(fromCents(amountInCents));
    }

    useEffect(()=>{
        stepUpdate(props.stepId, {amount});
    },[stepUpdate, props.stepId, amount]);    

    return (
        <Container fluid>
            <h4 className={`${styles.title}`}>How much do you want to refund?</h4>
            <span className={styles.subtitle}>Up to ${maxTotal.toFixed(2)}</span>
            <hr/>
            <Row>
                <Col sm={12} lg={3}>
                    <Form.Group controlId="refund-amount">
                        <Form.Label>Refund Amount</Form.Label>
                        <InputGroup>
                            <InputGroup.Prepend>
                                <InputGroup.Text>$</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control type="number" name="amount" min={0} max={maxTotal} step={0.01} value={amount} onChange={changeHandler} />
                        </InputGroup>
                    </Form.Group>
                    <Form.Check 
                        className="ps-0 form-switch"
                        id="admin-check"
                        name="admin-check"
                        type="checkbox" 
                        label={`Full Amount of $${maxTotal.toFixed(2)}`}
                        onChange={e => {
                            changeHandler({target: {value: e.target.checked ? maxTotal.toFixed(2) : 0}});
                        }}
                        checked={amount !== "" && +amount === maxTotal}
                    />
                </Col>
            </Row>
        </Container>
    );
}
